import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindAppsDownloadAndEngagementFilter from "../../../../models/AndroidDownloadAndEngagementFilter/AndroidDownloadAndEngagementFilter";
import DownloadEngagementFilter from "../DownloadEngagementFilter";

const AppAndroidDownloadEngagementFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsDownloadAndEngagementFilter>) => {
    return (
        <DownloadEngagementFilter
            filter={filter}
            value={value}
            hasDeviceFilter={false}
            onFilterUpdate={onFilterUpdate}
        />
    );
};

export default AppAndroidDownloadEngagementFilter;
